import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import ConfirmModal from 'components/ConfirmModal';
import { listFaq, toggleDrawer } from './action';
import { FaqTableConfig } from './FAQTableConfig';
import AddFAQDrawer from 'components/AddFAQDrawer';

function FAQ() {
  useInjectReducer({ key: 'faq', reducer });
  useInjectSaga({ key: 'faq', saga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedFaq, setselectedFaq] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const faqState = useSelector((state) => state.faq || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = FaqTableConfig(
      handleSearch,
      handleReset,
      // onDelete,
      editUserFaq,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listFaq({ page: 1, limit: 10 }));
  }, []);

  // const onDelete = (item) => {
  //   if (!_.isNil(item)) {
  //     setselectedFaq(item);
  //     dispatch(toggleDeleteModal());
  //     return;
  // };
  // dispatch(deleteQuote(selectedFaq.quote_id));
  // console.log(item);
  // }
  const resetPagination = () => setCurrentPage(1);

  const editUserFaq = (faq) => {
    setselectedFaq(faq);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listFaq(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listFaq({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };
  // const handleDeleteModalToggle = () => dispatch(toggleDeleteModal());

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listFaq({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="FAQ's"
        extra={
          <AddFAQDrawer
            initialState={initialState}
            selectedFaq={selectedFaq}
            resetPagination={resetPagination}
            editUserFaq={editUserFaq}
            roleAddResponsibility={_.includes(
              authState.userResponsibilities,
              'ADD_FAQ_BUTTON',
            )}
          />
        }
      >
        <Table
          columns={columns}
          loading={faqState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={faqState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={faqState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={faqState.loading}
          onChange={onPageChange}
        />
      </Card>
      {/* <ConfirmModal
        title={'Delete Quote Confirmation'}
        text={'Are you sure you want to delete this quote ?'}
        toggle={faqState.deleteModal}
        loading={faqState.loading}
        handleDeleteModalToggle={handleDeleteModalToggle}
        onDelete={onDelete}
      /> */}
    </>
  );
}

export default FAQ;
